module.exports = __webpack_public_path__ + "img/left-right-pattern-light.3aaef0d.svg";